import { render, staticRenderFns } from "./Theme.vue?vue&type=template&id=b0540470&"
import script from "./Theme.vue?vue&type=script&lang=js&"
export * from "./Theme.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Ramon/PROYECTOS/JuanGabriel_POS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b0540470')) {
      api.createRecord('b0540470', component.options)
    } else {
      api.reload('b0540470', component.options)
    }
    module.hot.accept("./Theme.vue?vue&type=template&id=b0540470&", function () {
      api.rerender('b0540470', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/settings/Theme.vue"
export default component.exports